import React from 'react';
function Undo({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        d="M15.432 19.656s3.898-3.868 1.268-8.648c-1.735-3.154-6.473-3.106-6.473-3.106l-4.546.98"
      />
      <path strokeLinecap="round" d="M8.59 4.202L5.68 8.898l4.63 2.94" />
    </svg>
  );
}

export default Undo;
